import { AffineErrorBoundary } from '@affine/core/components/affine/affine-error-boundary';
import { WorkspaceService } from '@affine/core/modules/workspace';
import { useService } from '@toeverything/infra';
import type { ReactElement } from 'react';

import { CloudGuestsPanel } from './cloud-guests-panel';

export const GuestsPanel = (): ReactElement | null => {
  const workspace = useService(WorkspaceService).workspace;

  // Guests are only available on cloud workspaces
  if (workspace.flavour === 'local') {
    return null;
  }

  return (
    <AffineErrorBoundary>
      <CloudGuestsPanel />
    </AffineErrorBoundary>
  );
};
